import { useMutation, useQueryClient } from '@tanstack/react-query'
import { productApi } from 'services'
import type { ProductSyncMode } from 'services/productApi'
import { useSnackbar } from 'contexts'
import { getErrorMessage } from 'utils'

/**
 * VRG-102 — set a product's per-product provider→Vera re-sync override
 * (inherit / always_sync / locked).
 */
export const useProductSyncMode = () => {
  const queryClient = useQueryClient()
  const { open: notification } = useSnackbar()

  return useMutation({
    mutationFn: ({ productId, syncMode }: { productId: string; syncMode: ProductSyncMode }) =>
      productApi.setSyncMode(productId, syncMode),
    onSuccess: (product) => {
      queryClient.invalidateQueries({ queryKey: ['product', product.id] })
      queryClient.invalidateQueries({ queryKey: ['products'] })
    },
    onError: (error: any) => {
      notification({
        type: 'error',
        title: 'Could not update sync setting',
        text: getErrorMessage(error) || 'Failed to update sync mode',
      })
    },
  })
}
